import React from 'react';

import { Code } from '@atlaskit/code';
import { Text } from '@atlaskit/primitives/compiled';
import { Table, TBody, TD, TH, THead, TR } from '@atlaskit/table/primitives';

import HorizontalScrollContainer from '../horizontal-scroll-container';

const values: BorderValue[] = [
	{
		tokenName: 'border.width',
		suitableFor: 'The default width for all standard component borders and dividers.',
		value: '1px',
	},
	{
		tokenName: 'border.width.selected',
		suitableFor:
			'The width used to indicate a selected element, such as an active tab or a chosen item.',
		value: '2px',
	},
	{
		tokenName: 'border.width.focused',
		suitableFor: 'The width used for the focus ring on interactive elements.',
		value: '2px',
	},
];

type BorderValue = {
	tokenName: string;
	suitableFor: string;
	value: string;
};

/**
 * __Border table__
 */
export const BorderTable = (): React.JSX.Element => {
	return (
		<HorizontalScrollContainer>
			<Table testId="border-table">
				<THead>
					<TR isBodyRow={false}>
						<TH width="200px">Token name</TH>
						<TH width="400px">Suitable for</TH>
						<TH width="70px">Value*</TH>
					</TR>
				</THead>
				<TBody>
					{values.map((token) => {
						return (
							<TR key={token.tokenName}>
								<TD>
									<Code>{token.tokenName}</Code>
								</TD>
								<TD>
									<Text>{token.suitableFor}</Text>
								</TD>
								<TD>
									<Text>{token.value}</Text>
								</TD>
							</TR>
						);
					})}
				</TBody>
			</Table>
		</HorizontalScrollContainer>
	);
};
